

// import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import { requestForToken } from "../../firebase"; // ✅ adjust if path is different

// const InfluencerLogin = () => {
//   const navigate = useNavigate();

//   const [userdata, setUserdata] = useState({
//     email: "",
//     password: "",
//   });

//   const [passwordType, setPasswordType] = useState("password");

//   // ✅ Request FCM token on mount and save in localStorage
//   useEffect(() => {
//     requestForToken(); // This will automatically store the token in localStoragess
//   }, []);

//   const handleInput = (e) => {
//     const { name, value } = e.target;
//     setUserdata({ ...userdata, [name]: value });
//   };

//   const togglePassword = () => {
//     setPasswordType(passwordType === "password" ? "text" : "password");
//   };

//   const postdata = async (e) => {
//     e.preventDefault();
//     const { email, password } = userdata;

//     const res = await fetch("https://server-side-influencer.onrender.com/influencer/influencerlogin", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ email, password }),
//     });

//     const data = await res.json();

//     if (res.status === 200) {
//       toast.success(data.message);
//       const influencerId = data.user.influencerId;

//       localStorage.setItem("influcertoken", data.token);
//       localStorage.setItem("influencerID", influencerId);
//       sessionStorage.setItem("sessionId", data.sessionId);
//       navigate("/InfluencerHome?page=1");

//       // ✅ Send FCM token to backend
//       const savedFcmToken = localStorage.getItem("fcmToken");
//       if (savedFcmToken) {
//         await fetch("https://server-side-influencer.onrender.com/influencer/save-fcm-token", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             influencerId,
//             fcmToken: savedFcmToken,
//           }),
//         })
//           .then((res) => res.json())
//           .then((data) => {
//             console.log("✅ FCM token sent to backend:", data);
//           })
//           .catch((err) => {
//             console.error("❌ Error sending FCM token:", err);
//           });
//       } else {
//         console.warn("⚠️ No FCM token found in localStorage");
//       }
//     } else {
//       toast.error(data.error);
//     }
//   };
// // 👇 Place this inside the InfluencerLogin component, below other functionsssdddddddd
// const handleGoogleLogin = async () => {
//   const auth = getAuth();
//   const provider = new GoogleAuthProvider();
//   try {
//     const result = await signInWithPopup(auth, provider);
//     const idToken = await result.user.getIdToken();

//     const res = await fetch("https://server-side-influencer.onrender.com/influencer/google-login", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ idToken }),
//     });

//     const data = await res.json();

//     if (res.status === 200) {
//       toast.success("Google login successful");

//       // ✅ Store influencer ID and token
//       localStorage.setItem("influencerID", data.influencerId);
//       localStorage.setItem("influcertoken", data.token);

//       // ✅ Navigate
//       navigate("/InfluencerHome?page=1");

//       // ✅ Optional: send saved FCM tokensss
//       const savedFcmToken = localStorage.getItem("fcmToken");
//       if (savedFcmToken) {
//         await fetch("https://server-side-influencer.onrender.com/influencer/save-fcm-token", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             influencerId: data.influencerId,
//             fcmToken: savedFcmToken,
//           }),
//         });
//       }
//     } else {
//       toast.error(data.error || "Google login failed");
//     }
//   } catch (err) {
//     console.error("Google login error:", err);
//     toast.error("Google sign-in failed");
//   }
// };

//   const navigateToSignUp = () => navigate("/InfluencerSignUp");
//   const navigateToForgotPassword = () => navigate("/influenceremail");
//   const handleBackToHome = () => navigate("/");

//   return (
//     <div className="font-[sans-serif]">
//       <div className="min-h-screen flex flex-col items-center justify-center py-6 px-4">
//         <div className="grid md:grid-cols-2 items-center gap-4 max-w-6xl w-full">
//           <div className="border border-gray-300 rounded-lg p-6 max-w-md shadow-lg max-md:mx-auto">
//             <form className="space-y-4" onSubmit={postdata}>
//               <div className="mb-8">
//                 <h3 className="text-gray-800 text-3xl font-extrabold">Sign in as influencer</h3>
//                 <p className="text-gray-500 text-sm mt-4 leading-relaxed">
//                   Sign in as an influencer and connect with top brands, grow your reach, and unlock new collaboration opportunities.
//                 </p>
//               </div>

//               <div>
//                 <label className="text-gray-800 text-sm mb-2 block">Email</label>
//                 <div className="relative flex items-center">
//                   <input
//                     name="email"
//                     type="email"
//                     required
//                     className="w-full text-sm text-gray-800 border border-gray-300 px-4 py-3 rounded-lg outline-blue-600"
//                     placeholder="Enter email"
//                     value={userdata.email}
//                     onChange={handleInput}
//                   />
//                 </div>
//               </div>

//               <div>
//                 <label className="text-gray-800 text-sm mb-2 block">Password</label>
//                 <div className="relative flex items-center">
//                   <input
//                     name="password"
//                     type={passwordType}
//                     required
//                     className="w-full text-sm text-gray-800 border border-gray-300 px-4 py-3 rounded-lg outline-blue-600"
//                     placeholder="Enter password"
//                     value={userdata.password}
//                     onChange={handleInput}
//                   />
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     fill="#bbb"
//                     stroke="#bbb"
//                     className="w-[18px] h-[18px] absolute right-4 cursor-pointer"
//                     viewBox="0 0 24 24"
//                     onClick={togglePassword}
//                   >
//                     {passwordType === "password" ? (
//                       <path d="M12 4C8.13 4 5 6.91 5 10s3.13 6 7 6 7-2.91 7-6-3.13-6-7-6zm0 10c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" />
//                     ) : (
//                       <path d="M12 4C8.13 4 5 6.91 5 10s3.13 6 7 6 7-2.91 7-6-3.13-6-7-6zm0 10c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" />
//                     )}
//                   </svg>
//                 </div>
//               </div>

//               <div className="flex flex-wrap items-center justify-between gap-4">
//                 <div className="text-sm">
//                   <a
//                     href="javascript:void(0);"
//                     className="text-blue-600 hover:underline font-semibold"
//                     onClick={navigateToForgotPassword}
//                   >
//                     Forgot your password?
//                   </a>
//                 </div>
//               </div>

//               <div className="!mt-8">
//                 <button
//                   type="submit"
//                   className="w-full shadow-xl py-3 px-4 text-sm tracking-wide rounded-lg text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:outline-none focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-800"
//                 >
//                   Log in
//                 </button>
//               </div>
// <div className="my-3 text-center text-gray-500 text-sm">or</div>

// <button
//   type="button"
//   onClick={handleGoogleLogin}
//   className="flex items-center justify-center gap-2 w-full mt-2 py-3 px-4 text-sm tracking-wide rounded-lg text-black bg-white border border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-red-300"
// >
//   <svg className="w-5 h-5" viewBox="0 0 533.5 544.3">
//     <path
//       fill="#4285F4"
//       d="M533.5 278.4c0-17.4-1.4-34.1-4.1-50.2H272v95.1h146.9c-6.4 34.6-25.4 63.9-54.2 83.5v68h87.7c51.3-47.2 81.1-116.8 81.1-196.4z"
//     />
//     <path
//       fill="#34A853"
//       d="M272 544.3c73.5 0 135.2-24.4 180.3-66.5l-87.7-68c-24.4 16.3-55.6 25.9-92.6 25.9-71.3 0-131.8-48.1-153.5-112.6h-90v70.5C80.9 483.3 169.7 544.3 272 544.3z"
//     />
//     <path
//       fill="#FBBC05"
//       d="M118.5 323.1c-10.3-30.2-10.3-62.7 0-92.9v-70.5h-90c-37.3 74.6-37.3 159.4 0 234z"
//     />
//     <path
//       fill="#EA4335"
//       d="M272 107.7c39.9-.6 78.3 13.9 107.5 40.9l80.2-80.2C405.3 24.4 343.6 0 272 0 169.7 0 80.9 61 28.5 159.7l90 70.5c21.6-64.6 82.2-112.6 153.5-112.6z"
//     />
//   </svg>
//   Log in with Google
// </button>

//               <p className="text-sm !mt-8 text-center text-gray-800">
//                 Don't have an account?{" "}
//                 <span
//                   className="text-blue-600 font-semibold hover:underline ml-1 whitespace-nowrap cursor-pointer"
//                   onClick={navigateToSignUp}
//                 >
//                   Register here
//                 </span>
//               </p>
//             </form>
//           </div>

//        <div className="flex items-center justify-center max-md:mt-8 space-x-4">
//   <img
//     src="/logo-ico.png"
//     alt="Logo"
//     className="w-90 h-20 object-contain"
//   />
//   <span className="text-black text-2xl font-semibold">for influencers</span>
// </div>
//         </div>
//       </div>
//       <ToastContainer autoClose={500} />
//     </div>
//   );
// };

// export default InfluencerLogin;



import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { requestForToken } from "../../firebase";
import "react-toastify/dist/ReactToastify.css";

const InfluencerLogin = () => {
  const navigate = useNavigate();

  const [userdata, setUserdata] = useState({
    email: "",
    password: "",
  });

  const [passwordType, setPasswordType] = useState("password");

  // Request FCM token on mount
  useEffect(() => {
    requestForToken();
  }, []);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setUserdata({ ...userdata, [name]: value });
  };

  const togglePassword = () => {
    setPasswordType((prev) =>
      prev === "password" ? "text" : "password"
    );
  };

  const sendFcmToBackend = async (influencerId) => {
    const savedFcmToken = localStorage.getItem("fcmToken");
    if (!savedFcmToken) return;

    try {
      await fetch(
        "https://server-side-influencer.onrender.com/influencer/save-fcm-token",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            influencerId,
            fcmToken: savedFcmToken,
          }),
        }
      );
    } catch (error) {
      console.error("Error sending FCM token:", error);
    }
  };

  const postdata = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(
        "https://server-side-influencer.onrender.com/influencer/influencerlogin",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(userdata),
        }
      );

      const data = await res.json();

      if (res.status === 200) {
        toast.success(data.message);

        const influencerId = data.user.influencerId;

        localStorage.setItem("influcertoken", data.token);
        localStorage.setItem("influencerID", influencerId);
        sessionStorage.setItem("sessionId", data.sessionId);

        await sendFcmToBackend(influencerId);

        navigate("/InfluencerHome?page=1");
      } else {
        toast.error(data.error);
      }
    } catch (error) {
      toast.error("Login failed. Try again.");
    }
  };

  const handleGoogleLogin = async () => {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();

    try {
      const result = await signInWithPopup(auth, provider);
      const idToken = await result.user.getIdToken();

      const res = await fetch(
        "https://server-side-influencer.onrender.com/influencer/google-login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ idToken }),
        }
      );

      const data = await res.json();

      if (res.status === 200) {
        toast.success("Google login successful");

        localStorage.setItem("influencerID", data.influencerId);
        localStorage.setItem("influcertoken", data.token);

        await sendFcmToBackend(data.influencerId);

        navigate("/InfluencerHome?page=1");
      } else {
        toast.error(data.error || "Google login failed");
      }
    } catch (error) {
      toast.error("Google sign-in failed");
    }
  };

  const navigateToSignUp = () => navigate("/InfluencerSignUp");
  const navigateToForgotPassword = () =>
    navigate("/influenceremail");

  return (
    <div className="font-[sans-serif]">
      <div className="min-h-screen flex flex-col items-center justify-center py-6 px-4">
        <div className="grid md:grid-cols-2 items-center gap-6 max-w-6xl w-full">

          {/* LOGIN CARD */}
          <div className="border border-gray-300 rounded-lg p-6 max-w-md shadow-lg max-md:mx-auto">
            <form className="space-y-4" onSubmit={postdata}>
              <div className="mb-6">
                <h3 className="text-gray-800 text-3xl font-extrabold">
                  Sign in as Influencer
                </h3>
                <p className="text-gray-500 text-sm mt-3">
                  Connect with top brands, grow your reach,
                  and unlock collaboration opportunities.
                </p>
              </div>

              <div>
                <label className="text-sm text-gray-700 mb-2 block">
                  Email
                </label>
                <input
                  name="email"
                  type="email"
                  required
                  className="w-full border px-4 py-3 rounded-lg outline-blue-600"
                  placeholder="Enter email"
                  value={userdata.email}
                  onChange={handleInput}
                />
              </div>

              <div>
                <label className="text-sm text-gray-700 mb-2 block">
                  Password
                </label>
                <div className="relative">
                  <input
                    name="password"
                    type={passwordType}
                    required
                    className="w-full border px-4 py-3 rounded-lg outline-blue-600"
                    placeholder="Enter password"
                    value={userdata.password}
                    onChange={handleInput}
                  />
                  <span
                    onClick={togglePassword}
                    className="absolute right-4 top-3 cursor-pointer text-gray-400"
                  >
                    👁
                  </span>
                </div>
              </div>

              <div className="text-right">
                <button
                  type="button"
                  onClick={navigateToForgotPassword}
                  className="text-blue-600 text-sm hover:underline"
                >
                  Forgot password?
                </button>
              </div>

              <button
                type="submit"
                className="w-full py-3 rounded-lg text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:opacity-90"
              >
                Log in
              </button>

              <div className="text-center text-gray-500 text-sm">
                or
              </div>

              <button
                type="button"
                onClick={handleGoogleLogin}
                className="w-full flex items-center justify-center gap-2 py-3 rounded-lg border hover:bg-gray-100"
              >

                     <svg className="w-5 h-5" viewBox="0 0 533.5 544.3">
                  <path
                    fill="#4285F4"
                    d="M533.5 278.4c0-17.4-1.4-34.1-4.1-50.2H272v95.1h146.9c-6.4 34.6-25.4 63.9-54.2 83.5v68h87.7c51.3-47.2 81.1-116.8 81.1-196.4z"
                  />
                  <path
                    fill="#34A853"
                    d="M272 544.3c73.5 0 135.2-24.4 180.3-66.5l-87.7-68c-24.4 16.3-55.6 25.9-92.6 25.9-71.3 0-131.8-48.1-153.5-112.6h-90v70.5C80.9 483.3 169.7 544.3 272 544.3z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M118.5 323.1c-10.3-30.2-10.3-62.7 0-92.9v-70.5h-90c-37.3 74.6-37.3 159.4 0 234z"
                  />
                  <path
                    fill="#EA4335"
                    d="M272 107.7c39.9-.6 78.3 13.9 107.5 40.9l80.2-80.2C405.3 24.4 343.6 0 272 0 169.7 0 80.9 61 28.5 159.7l90 70.5c21.6-64.6 82.2-112.6 153.5-112.6z"
                  />
                </svg>
                Log in with Google
              </button>

              <p className="text-sm text-center mt-6">
                Don't have an account?{" "}
                <span
                  onClick={navigateToSignUp}
                  className="text-blue-600 font-semibold cursor-pointer hover:underline"
                >
                  Register here
                </span>
              </p>
            </form>
          </div>

          {/* LOGO SECTION */}
          <div className="flex items-center justify-center max-md:mt-8">
            <div className="flex items-center gap-3">
              <img
                src="https://i.postimg.cc/Rhd5hYcN/halfolog-removebg-preview.png"
                alt="Influenceso Logo"
                className="h-12 w-auto"
              />
                  <h2 className="text-2xl font-semibold text-black flex items-baseline gap-2">
      <span className="font-bold">Influenceso</span>
      <span className="text-gray-600 text-lg">for influencers</span>
    </h2>
            </div>
          </div>

        </div>
      </div>

      <ToastContainer autoClose={500} />
    </div>
  );
};

export default InfluencerLogin;